var _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8, _rect, _path9, _path0, _path1, _path10, _circle3, _path11, _circle4, _path12, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhConsumerAllSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 786.049,
    height: 610.187,
    viewBox: "0 0 786.049 610.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "undraw_feeling-of-joy_devp",
    transform: "translate(0 0)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_308",
    "data-name": "Ellipse 308",
    cx: 364.263,
    cy: 12.033,
    rx: 364.263,
    ry: 12.033,
    transform: "translate(0 586.121)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_309",
    "data-name": "Ellipse 309",
    cx: 44.849,
    cy: 44.849,
    r: 44.849,
    transform: "translate(313.944 105.907)",
    fill: "#a47cea"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10376",
    "data-name": "Path 10376",
    d: "M566.672,405.041,546.378,389.51l-72.655,131.6a11.815,11.815,0,1,0,13.8,9.919Z",
    transform: "translate(-219.742 -150.586)",
    fill: "#ffb8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10377",
    "data-name": "Path 10377",
    d: "M739.76,480.552a11.822,11.822,0,0,0-11.649-7.952L611.049,380.773,593.49,399.341,716.81,485.3a11.816,11.816,0,1,0,22.95-4.745Z",
    transform: "translate(-207.586 -151.406)",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10378",
    "data-name": "Path 10378",
    d: "M362.3,539.6h13.792l6.563-53.194H362.3Z",
    transform: "translate(34.014 45.665)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10379",
    "data-name": "Path 10379",
    d: "M0,0H43.344V16.746h-26.6A16.746,16.746,0,0,1,0,0H0Z",
    transform: "translate(436.702 598.069) rotate(180)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10380",
    "data-name": "Path 10380",
    d: "M262.4,527.971l12.67,5.445,27.034-46.281L283.4,479.1Z",
    transform: "translate(24.635 44.979)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10381",
    "data-name": "Path 10381",
    d: "M0,0H43.344V16.746h-26.6A16.746,16.746,0,0,1,0,0Z",
    transform: "translate(319.081 600.664) rotate(-156.744)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10382",
    "data-name": "Path 10382",
    d: "M548.036,473.187l-65.6,206.672,86.107,9.226L576.807,568.3l11.207,120.784,69.705-8.2s-12.592-191.3-35.511-203.6S548.036,473.187,548.036,473.187Z",
    transform: "translate(-218.013 -142.981)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_310",
    "data-name": "Ellipse 310",
    cx: 28.702,
    cy: 28.702,
    r: 28.702,
    transform: "translate(336.892 149.012)",
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10383",
    "data-name": "Path 10383",
    d: "M578.271,492.28c-19.93,0-39.109-.883-40.1-2.6a.725.725,0,0,1,.141-.9c1.371-2.019-1.848-34.837-8.627-87.769a27.419,27.419,0,0,1,18.058-29.219l.127-.029,60.07-5.932.673.189a27.176,27.176,0,0,1,19.862,27.518c-1.549,33.766-4.148,90.957-4.148,94.6,0,.992-1.381,1.489-2.584,1.812C615.9,491.519,596.761,492.28,578.271,492.28Zm-39.184-2.727Z",
    transform: "translate(-213.596 -152.809)",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1381",
    "data-name": "Rectangle 1381",
    width: 107.201,
    height: 107.201,
    transform: "matrix(0.625, -0.781, 0.781, 0.625, 55.156, 184.575)",
    fill: "#f2f2f2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10384",
    "data-name": "Path 10384",
    d: "M368.868,422.344a24.065,24.065,0,1,1,27.417-20.164,24.065,24.065,0,0,1-27.417,20.164Zm6.924-45.418a21.878,21.878,0,1,0,18.331,24.925h0a21.9,21.9,0,0,0-18.331-24.925Z",
    transform: "translate(-230.594 -151.996)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10385",
    "data-name": "Path 10385",
    d: "M320.521,670.06c-8.215,27.442,4.535,55.5,4.535,55.5s26.069-16.435,34.284-43.877-4.535-55.5-4.535-55.5S328.736,642.619,320.521,670.06Z",
    transform: "translate(-233.473 -128.366)",
    fill: "#e6e6e6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10386",
    "data-name": "Path 10386",
    d: "M335.226,670.873c6.914,27.8-7.142,55.223-7.142,55.223s-25.266-17.644-32.18-45.442,7.142-55.223,7.142-55.223S328.312,643.075,335.226,670.873Z",
    transform: "translate(-235.704 -128.437)",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10387",
    "data-name": "Path 10387",
    d: "M538.024,318.713a99.116,99.116,0,0,0,49.818,12.037c6.655-.173,13.987-1.383,18.2-6.536,4.755-5.814,3.565-14.9-1.022-20.847s-11.763-9.3-18.922-11.575c-6.773-2.152-14.031-3.537-20.977-2.033a26.121,26.121,0,0,0-18.929,34.7",
    transform: "translate(-212.794 -160.01)",
    fill: "#a47cea"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_311",
    "data-name": "Ellipse 311",
    cx: 25.159,
    cy: 25.159,
    r: 25.159,
    transform: "translate(301.912 93.874)",
    fill: "#a47cea"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10388",
    "data-name": "Path 10388",
    d: "M980.831,292.914l-98.761-57.561,12.669-21.737a5.469,5.469,0,1,0-9.451-5.508L872.62,229.845,773.86,172.283a8.751,8.751,0,0,0-11.967,3.154L684.777,307.748a8.751,8.751,0,0,0,3.154,11.968l98.761,57.561L700.212,525.654a5.469,5.469,0,0,0,9.451,5.508l86.479-148.377L894.9,440.346a8.751,8.751,0,0,0,11.967-3.154l77.116-132.311a8.75,8.75,0,0,0-3.154-11.967Z",
    transform: "translate(-199.128 -171.091)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 10.939,
    cy: 41.568,
    rx: 10.939,
    ry: 41.568,
    transform: "matrix(0.504, -0.864, 0.864, 0.504, 567.393, 169.103)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_313",
    "data-name": "Ellipse 313",
    cx: 52.506,
    cy: 52.506,
    r: 52.506,
    transform: "translate(582.747 82.717)",
    fill: "#a47cea"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10389",
    "data-name": "Path 10389",
    d: "M847.271,321.418c-3.042,5.22-24.5,8.511-40.157-.615s-19.589-27.215-16.547-32.435,11.905,4.407,27.564,13.533S850.313,316.2,847.271,321.418Z",
    transform: "translate(-189.174 -160.219)",
    fill: "#f2f2f2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_314",
    "data-name": "Ellipse 314",
    cx: 10.939,
    cy: 10.939,
    r: 10.939,
    transform: "translate(612.887 96.1)",
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_315",
    "data-name": "Ellipse 315",
    cx: 10.939,
    cy: 10.939,
    r: 10.939,
    transform: "translate(652.58 119.235)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhConsumerAllSet);
export default __webpack_public_path__ + "static/media/nh_consumer_all_set.7145c07ca842dfe351764d21a435311e.svg";
export { ForwardRef as ReactComponent };